import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import swal from 'sweetalert'

import Axios from "axios";
import Config from "../../config.js"

var jalaali = require('jalaali-js')


const useStyles = makeStyles(styles);

export default function Profile(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    isCollegian: user && user.isCollegian,
    name: user && user.name,
    educations: user && user.educations,
    educationLevel: null,
    educationYear: null,
    field: "",
    university: "",
  });
  var Call = () => {
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      educations: state.educations,
      isCollegian: state.isCollegian
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const handleCheckBoxChange = (event) => {
    var t = event.target.checked;
    setState({ ...state, isCollegian: t });

  };
  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const handleDropDownChange = (event) => {
    if (event.target.value == 'true' || event.target.value == 'false')
      setState({ ...state, [event.target.name]: Boolean(event.target.value) });
    else setState({ ...state, [event.target.name]: (event.target.value) });
  };
  const addToEducationList = () => {
    if (state.educationLevel == null || state.field == "" || state.university == "" || state.educationYear == null)
      return swal("هیچ یک از مقادیر نمی تواند خالی باشد.");
    state.educations.push(state.educationLevel + " " + state.field + "، ورودی " + state.educationYear + "،  " + state.university)
    setState({ ...state, "educations": state.educations })
    setState({ ...state, "educationYear": null, "educationLevel": null, "university": "", "field": "" })
  };
  const removeFromList = (source, tttt, valueToRemove) => {
    var e = source.filter(item => item !== valueToRemove)
    setState({ ...state, [tttt]: e })
  };
  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >
            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>

                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    سوابق تحصیلی
      </Typography>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="educationLevel">مرتبه علمی</InputLabel>
                      <Select
                        value={state.educationLevel}
                        onChange={handleDropDownChange}
                        inputProps={{
                          name: 'educationLevel',
                          id: 'educationLevel',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        <MenuItem value={"دیپلم"}>دیپلم</MenuItem>
                        <MenuItem value={"کارشناسی"}>کارشناسی</MenuItem>
                        <MenuItem value={"کارشناسی ارشد"}>کارشناسی ارشد</MenuItem>
                        <MenuItem value={"دکتری"}>دکتری</MenuItem>
                        <MenuItem value={"پسا دکتری"}>پسا دکتری</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className={classes.formInput}>
                    <TextField id="standard-basic" name="field" value={state.field} onChange={handleTextBoxChange} label="رشته تحصیلی" helperText="مثال: مهندسی کامپیوتر، نرم افزار" />
                  </div>
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" name="university" value={state.university} onChange={handleTextBoxChange} label="دانشگاه" helperText="مثال: دانشگاه صنعتی شریف" />
                  </div>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="educationYear">ورودی</InputLabel>
                      <Select
                        value={state.educationYear}
                        onChange={handleDropDownChange}
                        inputProps={{
                          name: 'educationYear',
                          id: 'educationYear',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        {function () {
                          var rows = [];
                          var j = jalaali.toJalaali(new Date())
                          var year = j.jy;
                          for (var i = year; i >= 1350; i--) {
                            rows.push(<MenuItem value={i}>{i}</MenuItem>);
                          }
                          return (rows);
                        }()}
                      </Select>
                    </FormControl>
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="outlined" color="secondary" disableElevation onClick={addToEducationList}>
                      افزودن به لیست
</Button>
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <FormControlLabel
                      control={<Checkbox checked={state.isCollegian} onChange={handleCheckBoxChange} name="isCollegian" />}
                      label="هم اکنون دانشجوام"
                    /></div>

                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={7}>
                <div className={classes.div}>
                  {user && state.educations.length > 0 ? (
                    <div className={classes.formInput + " " + classes.chipMargin}>
                      {user && state.educations.map((education) => {
                        return (
                          <Chip variant="outlined" label={education} onDelete={() => { removeFromList(state.educations, 'educations', education) }} color="primary" />
                        );
                      })}
                    </div>
                  ) : <p><br />موردی جهت نمایش وجود ندارد.</p>}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en + " " + classes.save}>
                  <Button variant="contained" color="primary" disableElevation onClick={Call}>
                    ذخیره سازی
                  </Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
      </GridContainer>
    </form>
  );
}